const RequestPropsReducer = (state ={unique : null},action) => {
    switch (action.type) {
        case "RequestPropsReducerSetUnique":
            state = {
              ...state,
              unique : action.payload.unique,
            }
            break;
        default:
        	break;
    }
    return state;
};

export default RequestPropsReducer;



// WEBPACK FOOTER //
// ./src/App/store/request.props.js